import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SpinnerState, spinnerFeatureKey } from './spinner.reducer';

export const selectSpinnerState = createFeatureSelector<SpinnerState>(spinnerFeatureKey);

export const getShowSpinner = createSelector(selectSpinnerState, (state) => state.apiCallOngoing);